export const taskDetail = "/hwyc-fanyi/home/task/detail"
export const taskResultApi = "/hwyc-fanyi/task/test/result"
export const taskSaveTranslate =  '/hwyc-fanyi/task/saveTranslate'
export const uploadResumeFile =  '/hwyc-fanyi/task/uploadResumeFile'